// screenCache keeps each tab's last successful value in memory across tab
// switches: App.tsx mounts only the active tab's screen, so without this a
// screen would blank to a loading state every time she switches back to it.
// A screen with a cached value for its key renders it at once and refetches
// quietly behind it. A reload or sign-out clears it, and that is fine.
const values = new Map<string, unknown>()

export const screenCache = {
  get: <T>(key: string): T | undefined => values.get(key) as T | undefined,
  set: <T>(key: string, value: T): void => {
    values.set(key, value)
  },
  clearAll: (): void => {
    values.clear()
  },
}
